import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OrderDTO } from '../../../shared/order-dto';
import { Observable } from 'rxjs';
import { OrderShopifyDTO } from '../../../shared/order-shopify-dto';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  constructor(private http: HttpClient) { }

  updateAddress(orderId, address): Observable<OrderDTO> {
    return this.http.post<OrderDTO>(`/api/order/address/${orderId}`, { address })
  }

  getOrderByToken(url_token): Observable<OrderDTO> {
    return this.http.get(`/api/order/detail-token/${url_token}`) as Observable<OrderDTO>
  }

  getOrderReview(checkoutDTO): Observable<any> {
    return this.http.post(`/api/order/review/`, { checkoutDTO })
  }

  // #1358
  getOrderShopifyByToken(url_token): Observable<OrderShopifyDTO> {
    return this.http.get(`/api/order/detail-shopify-token/${url_token}`) as Observable<OrderShopifyDTO>
  }
}
